<template>
  <VBtn
    class="p-0 header__link text-capitalize d-flex align-items-center"
    color="secondary"
    text
    @click="onCLick"
  >
    <div class="px-1 d-flex align-items-center">
      <VIcon class="mr-2">
        mdi-arrow-left
      </VIcon>
      <span
        class="body-2 back-btn__text"
      >
        {{ $t('authForm.back') }}
      </span>
    </div>
  </VBtn>
</template>

<script lang="ts">
export default {
  name: 'SBackButton',
};
</script>

<script setup lang="ts">
import { useRouter } from '../../composables';

const props = defineProps({
  isRouterBack: {
    type: Boolean,
    default: true,
  },
});

const router = useRouter();

function onCLick() {
  if (props.isRouterBack) {
    router.go(-1);
  }
}
</script>
